/**
 * @param {string} color
 * @param {string} bgColor
 * @param {string} borderColor
 * @returns {string} polaris button style
 */
export const polarisButtonStyle = (color, bgColor, borderColor) =>
  `color:#${color}; background-color:#${bgColor}; border-color: #${borderColor}; border-width: 1px; border-style: solid; font-family: Amazon Ember; border-radius: 2px; padding: 5px 20px; font-weight: 700;letter-spacing: .25px;`;
